import { StringParam, NumberParam, useQueryParams } from 'use-query-params';
import { decodeDelimitedArray } from 'serialize-query-params';
import { Applicant } from 'src/utils/explorer';
import { Relation, Sex } from 'src/data';


const normalizeRelation = (val: string): Relation => {
  if (val === 'spouse') return Relation.Spouse;
  if (val === 'child') return Relation.Child;
  return Relation.Self;
};

const normalizeSex = (val: string): Sex => {
  return val === 'm' ? Sex.Male : Sex.Female;
};

const getApplicantString = (applicant: Applicant): string => {
  const sex = applicant.sex === Sex.Male ? 'm' : 'f';
  const relation =
    applicant.relation === Relation.Spouse
      ? 'spouse'
      : applicant.relation === Relation.Child
        ? 'child'
        : 'primary';
  return `${relation}-${applicant.age}-${sex}`;
};

const ApplicantsParam = {
  encode: (array: Array<Applicant>): string => {
    return array.reduce((acc, applicant) => {
      const str = getApplicantString(applicant);
      return acc ? `${acc},${str}` : str;
    }, '');
  },

  decode: (value?: string | (string | null)[] | null | undefined): Array<Applicant> => {
    const applicants = decodeDelimitedArray(value, ',') || [];

    return applicants.map((applicant) => {
      const [relation, age, sex] = applicant ? applicant.split('-') : [];

      return {
        relation: normalizeRelation(relation),
        age: parseInt(age),
        sex: normalizeSex(sex),
      };
    });
  },
};

export const useParams = () => {
  const [query] = useQueryParams({
    zip: StringParam,
    income: NumberParam,
    applicants: ApplicantsParam,
    year: NumberParam,
  });

  return query;
};
